<template>
  <textarea :class="{
      'iqos-textarea': true,
      'iqos-textarea-readonly': readonly
    }"  
    :readonly="readonly" :value="value" 
    rows="6"
    @blur="$emit('blur')"
    :placeholder="placeholder"
    @input="ev => $emit('input', ev.target.value)"></textarea>
</template>

<script>
export default {
    props: {
        value: String,
        readonly: {
            type: Boolean,
            default: true
        },
        placeholder: String
    }
}
</script>

<style scoped>
.iqos-textarea {
    border-radius: 4px;
    border: 1px solid #ededed;
    width: 100%;
    outline: none;
    color: #1d1d1b;
    background: #ffffff;
    -webkit-appearance: none;
    padding: 0.6vh 1vh;
    vertical-align: bottom;
}

.iqos-textarea-readonly {
    color: #ededed;
    background: transparent;
}
</style>